import { Box, type Colors, InfoDot, Text } from '@factorialco/deprecated-design-system'
import upperFirst from 'lodash/upperFirst'

interface Props {
  color: Colors
  label: string
}

const InfoDotMemo = ({ color, label }: Props) => (
  <Box flexDirection="row" alignItems="center" gap="s4">
    <InfoDot size="small" color={color} />
    <Text color="grey700" ellipsis size="100">
      {upperFirst(label)}
    </Text>
  </Box>
)

export default InfoDotMemo
